<div class="n-login-page">
  <div class="n-login-container">
    <!-- Logo -->
    <div class="n-login-logo">
      <img src="assets/icons/nomoh_logo.svg" alt="Nomoh Logo" />
    </div>

    <!-- Título -->
    <div class="n-login-header">
      <h1 class="n-login-title">{{ "PAGINA_LOGIN.TITULO" | translate }}</h1>
      <p class="n-login-subtitle">Acesse sua conta para continuar</p>
    </div>

    <!-- Formulário -->
    <form [formGroup]="form" class="n-login-form" (ngSubmit)="login()">
      <!-- Toggle Email/Telefone -->
      <div class="n-login-toggle">
        <button
          type="button"
          class="n-toggle-btn"
          [class.active]="valueLogin"
          (click)="alterarOpcaoLogin(true)"
        >
          Telefone
        </button>
        <button
          type="button"
          class="n-toggle-btn"
          [class.active]="!valueLogin"
          (click)="alterarOpcaoLogin(false)"
        >
          E-mail
        </button>
      </div>

      <!-- Campo Email/Telefone -->
      <div class="n-field-wrapper">
        @if(valueLogin) {
        <app-form-field
          label="{{ 'CAMPO_ENTRADA.TELEFONE.ROTULO' | translate }}"
          controlName="telefone"
          [required]="true"
        >
          <p-inputMask
            id="telefone"
            mask="(99) 99999-9999"
            formControlName="telefone"
            [ngClass]="validarClasseErro('telefone')"
          />
        </app-form-field>
        } @else {
        <app-form-field
          label="{{ 'CAMPO_ENTRADA.EMAIL.ROTULO' | translate }}"
          controlName="email"
          [required]="true"
        >
          <input
            pInputText
            id="email"
            autocomplete="username"
            formControlName="email"
            [ngClass]="validarClasseErro('email')"
          />
        </app-form-field>
        }
      </div>

      <!-- Campo Senha -->
      <div class="n-field-wrapper">
        <app-form-field
          label="{{ 'CAMPO_ENTRADA.SENHA.ROTULO' | translate }}"
          controlName="senha"
          [required]="true"
        >
          <p-password
            id="senha"
            formControlName="senha"
            [feedback]="false"
            [toggleMask]="true"
            autocomplete="current-password"
          ></p-password>
        </app-form-field>
        <!-- Link Esqueceu Senha -->
        <div class="n-forgot-password">
          <button
            type="button"
            class="n-link-text"
            routerLink="/recuperar-senha"
          >
            {{ "PAGINA_LOGIN.RECUPERAR_SENHA" | translate }}
          </button>
        </div>
      </div>

      <!-- Botão Entrar -->
      <div class="n-form-actions">
        <p-button
          type="submit"
          label="Entrar"
          styleClass="n-btn-primary n-btn-login"
          [loading]="loading()"
          [disabled]="!isFormValid"
        >
        </p-button>
      </div>
    </form>

    <!-- Link Cadastro -->
    <div class="n-register-link">
      <span>{{ "PAGINA_LOGIN.CADASTRO.DESCRICAO" | translate }}</span>
      <button type="button" class="n-link-bold" routerLink="/cadastro">
        {{ "PAGINA_LOGIN.CADASTRO.BOTAO" | translate }}
      </button>
    </div>
  </div>
</div>
